export default "__VITE_ASSET__50inFzZ3__"